export default __webpack_public_path__ + "static/media/morecheese.c9bcfc92.jpg";